const crateMessages = [
  "There is a waiting period of 2 years.",
  "This chair is unavailable in your area.",
  "Please contact customer support to purchase.",
  "Another user has already purchased this model.",
  "You are over the required age to purchase.",
  "Shipping delayed-- please try again in 6 months.",
  "This chair has stopped existing.",
  "You must donate one kidney to purchase.",
  "You have joined the queue to purchase.",
  "Please hold.",
  "No one wants to buy this, not even you.",
  "This model requires a convenience fee of $400.",
  "This chair is out of your network.",
  "This model has been discontinued, just now.",
  "Chair is deprecated.",
  "Please call your representative to purchase.",
  "Please stay on the line.",
  "Expected delivery: January 2030.",
  "This chair is not guaranteed to ship.",
  "This model requires a postage fee of $500.",
  "Assembly required- ships in pieces.",
  "This model is 3D printed only.",
  "You may not purchase this item.",
  "You may not recieve this item.",
  "Seller assumes no responsibility.",
  "This model only available in Canada.",
  "Chair under construction.",
  "You may not like this item.",
  "This model is no longer available.",
  "This chair is no longer available.",
  "Shipping delayed until 2030.",
  "Shipping cancelled on this item.",
  "Shipping convenience fee $499.",
  "Please stop trying to purchase.",
  "No purchase can be made.",
  "Not available in your neighborhood.",
  "Pickup only. Location: Far away.",
  "Delivery not available.",
  "Buy now. Recieve January 2030.",
  "Chair is not included in purchase.",
  "This model requires insurance.",
  "This model only available outside United States.",
  "Please contact your mother.",
  "No transaction can be made.",
  "ERROR 504",
  "Detecting problem with purchase.",
  "Loading reason why you can't have it...",
  "Chair is sold out.",
  "Chair has sold to another user.",
  "Price of chair has increased to $1,299.",
  "This chair is not your style.",
  "Please choose another model.",
  "Please choose another chair.",
  "Please choose to not purchase.",
  "Please call to pay us and not recieve chair.",
  "Available for low monthly $2,000 payments.",
  "Only available to elderly customers.",
  "Only available to residents of Europe.",
  "Item has been discontinued.",
  "Item out of stock.",
  "Does not fit in a bag.",
  "Ships without a box.",
  "Ships in a few months.",
  "Chair is not covered by your plan.",
  "This model is out of your network.",
  "Next available ship date: June 2030.",
  "Next available chair not available.",
  "Your purchase has been rejected.",
  "The chair you requested is not here at this time.",
  "Our payment partner is down for maintenance.",
  "Order failed.",
  "You will be charged for this item out of stock.",
  "Purchase not in progress.",
  "Cancelling request...",
  "Cancelling purchase...",
  "This purchse was rejected because it contained a chair.",
  "Transaction failed.",
  "You have insufficient funds to cover this transaction.",
  "We can't process your payment.",
  "Your credit card number has been preserved.",
  "We encountered an unexpected and serious error.",
  "Your account will be closed.",
  "Ships when available.",
  "Next available window: February 2030.",
  "Your order has not been recieved.",
];

export function getRandomCrateMessage() {
  return crateMessages[Math.floor(Math.random() * crateMessages.length)];
}

export default crateMessages;
